<template>
  <div>
    <SMenu bottom min-width="250px" rounded offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon x-large v-on="on">
          <Avatar :user="user" :initials="initials" />
        </v-btn>
      </template>

      <v-card>
        <v-list-item-content class="justify-center pb-0">
          <div class="mx-auto text-center">
            <Avatar :user="user" :initials="initials" />
            <div class="d-flex justify-center mt-2">
              <div>{{ `${user.name}` }}</div>
            </div>
            <v-list class="mt-5 pa-0">
              <v-list-item
                v-for="(item, i) in userMenu"
                class="primaryColor--text teal lighten-5 d-flex justify-start text-start font-weight-bold"
                :key="i"
                @click="methodLink(item.routeLink)"
                link
                ripple
              >
                <v-list-item-icon>
                  <v-icon color="primaryColor" v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-list-item-content>
      </v-card>
    </SMenu>
    <SAlert v-model="alert" :message="message" error @onClose="alert = false" />
  </div>
</template>

<script>
import Avatar from "@/components/avatar/Avatar";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "AvatarMenu",
  components: {
    Avatar,
  },
  data: () => ({
    userMenu: [
      {
        title: "Profile",
        icon: "fa-user-circle",
        routeLink: { name: "Home" },
      },
      {
        title: "Déconnexion",
        icon: "fa-door-open",
        routeLink: { name: "Login" },
      },
    ],
    alert: false,
    message: "",
  }),
  methods: {
    async methodLink(link) {
      if (link.name != "Login") {
        return this.$router.push({ name: link.name });
      } else {
        return await this.logout();
      }
    },
    async logout() {
      try {
        await this.logoutMethod();
        this.$router.push({ name: "Login" });
      } catch ({ error }) {
        this.message = error;
        this.alert = true;
      }
    },
    ...mapActions({
      logoutMethod: "auth/logout",
    }),
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      initials: "auth/getInitials",
    }),
  },
};
</script>

<style></style>
